const items = [
  {
    title: '暑期档重磅推荐',
    desc: '今夏最值得期待的动作大片与喜剧新片一次性打包，陪你度过炎热夏日。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20atmosphere%20with%20warm%20golden%20sunset%20lighting%2C%20dramatic%20clouds%20and%20film%20reel%20elements%2C%20epic%20scale%2C%20rich%20amber%20and%20bronze%20tones%2C%20movie%20poster%20aesthetic&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '动作片爱好者必看',
    desc: '从经典港式功夫到好莱坞硬核枪战，精选百余部高分动作电影合集。',
    img: 'https://readdy.ai/api/search-image?query=Intense%20action%20movie%20montage%20with%20dynamic%20motion%20and%20dramatic%20lighting%2C%20warm%20orange%20and%20deep%20shadow%20contrast%2C%20explosive%20atmosphere%2C%20cinematic%20composition%20with%20film%20texture&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '喜剧电影欢乐季',
    desc: '无论是国产爆笑喜剧还是好莱坞温情喜剧，在这里都能找到让您开怀一笑的作品。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20comedy%20film%20atmosphere%20with%20soft%20golden%20lighting%2C%20warm%20colors%20and%20playful%20composition%2C%20feel-good%20cinematic%20aesthetic%2C%20light%20and%20airy%20mood&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '经典修复珍藏系列',
    desc: '影史名作 4K 数字修复版陆续上线，用全新画质重温那些永不褪色的经典。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20sepia%20and%20warm%20cream%20tones%2C%20soft%20film%20grain%20texture%2C%20nostalgic%20old%20Hollywood%20atmosphere%2C%20elegant%20cinematic%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '华语电影新力量',
    desc: '聚焦最新华语佳片，从文艺片到商业类型片，见证华语电影的新突破与新表达。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20artistic%20atmosphere%20with%20warm%20red%20and%20gold%20tones%2C%20modern%20elegant%20composition%2C%20soft%20lantern%20glow%2C%20contemporary%20film%20aesthetic%20with%20cultural%20elements&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '高分纪录片频道',
    desc: 'BBC、国家地理等顶级纪录片资源持续更新，用真实影像打开看世界的新视角。',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20atmosphere%20with%20natural%20landscape%20wide%20shots%2C%20warm%20earth%20tones%2C%20soft%20natural%20lighting%2C%20contemplative%20and%20immersive%20composition%2C%20cinematic%20documentary%20aesthetic&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            精选策划专题，深度推荐不可错过的好电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                <h3 className="absolute bottom-3 left-4 right-4 font-heading text-sm md:text-base font-semibold text-background-50">
                  {item.title}
                </h3>
              </div>
              <div className="p-4">
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-medium cursor-pointer">
                  <span className="whitespace-nowrap">查看专题</span>
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}